import {SimpleLink} from "../common/SimpleLink";
import {BOL_PRODUCT_URL} from "../../App";
import {useState} from "react";

export const NavigationBar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    return (
        <nav className="sticky top-0 z-50 bg-surface-50/80 backdrop-blur-lg border-b border-surface-200/70 shadow-sm shadow-surface-900/[0.03]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">

                    <div className="flex items-center">
                        <a
                            href="/"
                            className="font-logo text-4xl text-brand-500 hover:text-brand-600 transition-colors focus-ring rounded-lg"
                        >
                            Peesential
                        </a>
                    </div>

                    <div className="hidden md:flex items-center gap-1">

                        <SimpleLink
                            name={"Hoe Het Werkt"}
                            href={"/#hoe-het-werkt"}
                            classNames="px-3 py-2 rounded-full font-medium hover:bg-surface-100 transition-colors"
                        />

                        <SimpleLink
                            name={"Veelgestelde Vragen"}
                            href={"/#veelgestelde-vragen"}
                            classNames="px-3 py-2 rounded-full font-medium hover:bg-surface-100 transition-colors"
                        />

                        <SimpleLink
                            name={"Koop Nu"}
                            href={BOL_PRODUCT_URL}
                            openInNewTab={true}
                            classNames="ml-2 px-5 py-2 rounded-full bg-brand-500 text-white font-semibold shadow-md shadow-brand-500/25 hover:bg-brand-600 hover:text-white hover:shadow-lg hover:shadow-brand-500/30 transition-all focus-ring"
                        />

                    </div>

                    <button
                        aria-label="Open menu"
                        aria-expanded={isMobileMenuOpen}
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        className="md:hidden p-2 -mr-2 rounded-lg text-surface-800 hover:bg-surface-100 transition-colors focus-ring"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                  d="M4 6h16M4 12h16M4 18h16"></path>
                        </svg>
                    </button>
                </div>
            </div>

            {isMobileMenuOpen && (
                <div className="md:hidden bg-surface-50 border-t border-surface-200">
                    <div className="px-4 py-3 space-y-1">

                        <SimpleLink
                            name={"Hoe Het Werkt"}
                            href={"/#hoe-het-werkt"}
                            classNames="px-3 py-2.5 rounded-lg font-medium hover:bg-surface-100 transition-colors"
                        />
                        <SimpleLink
                            name={"Veelgestelde Vragen"}
                            href={"/#veelgestelde-vragen"}
                            classNames="px-3 py-2.5 rounded-lg font-medium hover:bg-surface-100 transition-colors"
                        />
                        <SimpleLink
                            name={"Koop Nu"}
                            href={BOL_PRODUCT_URL}
                            openInNewTab={true}
                            classNames="mt-1 px-3 py-2.5 rounded-lg bg-brand-500 text-white font-semibold text-center hover:bg-brand-600 hover:text-white transition-colors"
                        />

                    </div>
                </div>
            )}
        </nav>
    );
};


